import { useEffect, useState } from "react";

type TypewriterProps = {
    text: string;
};

export const Typewriter = ({ text }: TypewriterProps) => {
    const [showText, setShowText] = useState(text);

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout>;
        if (showText !== text) {
            timer = setTimeout(() => {
                const newText =
                    !showText.length || text.startsWith(showText)
                        ? text.substring(0, showText.length + 1)
                        : showText.substring(0, showText.length - 1);
                setShowText(newText);
            }, 50);
        }
        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [showText, text]);

    //non-breaking space maintains height when text is empty
    return showText ? <>{showText}</> : <>&nbsp;</>;
};
